import React from 'react';
import {
  SafeAreaView,
  View,
  StyleSheet,
  Image,
  Text,
  Linking,
  TouchableOpacity,
  Platform,
  useWindowDimensions
} from 'react-native';

import Logo from './assets/icons/logo.svg';
import MyText from './MyText';
import stylesheet from './Style'
import axios from 'axios';

import MyRequests from './assets/icons/MyRequests.svg';
import NewRequest from './assets/icons/NewRequest.svg';
import Dashboard from './assets/icons/Dashboard.svg';
import Documents from './assets/icons/Documents.svg';
import MySVG from './assets/MySVG';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { AntDesign, Entypo, FontAwesome, FontAwesome5, MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons';

export default function WebFooter(props) {
    const css = stylesheet();

    const Link = (text, url) => {
        return <TouchableOpacity style={styles.link} onPress={() => url?Linking.openURL(url):false}>
            <MyText style={[css.s, styles.linkText]}>
                {text}
            </MyText>
        </TouchableOpacity>
    }
    
    return (
    <View style={{backgroundColor: '#461b6f', padding: 20, flexWrap: 'wrap', flexDirection: 'row'}}>
        <View style={[styles.column, {alignItems: 'center'}]}>
            <MySVG source={Logo} style={styles.logo} resizeMode={'contain'} />
            <MyText style={[css.xl, styles.logoText]}>
                FOOTPRINT
            </MyText>
        </View>
        <View style={styles.column}>
            
        </View>
        <View style={styles.column}>
            <MyText style={[css.sm, styles.headerText]}>
                COMPANY
            </MyText>
            {Link('About Us', null)}
            {Link('Investor Relations', null)}
            {Link('Careers', null)}
            {Link('Press', null)}
            {Link('Trust & Safety', null)}
            {Link('Terms of Service', null)}
            {Link('Privacy Policy', null)}            
        </View>
        <View style={styles.column}>
            <MyText style={[css.sm, styles.headerText]}>
                RESOURCES
            </MyText>
            {Link('Customer Support', null)}
            {Link('Business Resources', null)}
            {Link('Customer Stories', null)}
        </View>
        <View style={styles.column}>
            <MyText style={[css.sm, styles.headerText]}>
                GET THE APP
            </MyText>
            {Link('iOS', 'https://apps.apple.com/us/app/application-footprint/id6446500693')}
            {Link('Android', 'https://play.google.com/store/apps/details?id=gr.mdata.footprint')}
        </View>
        <View style={styles.column}>
            <MyText style={[css.sm, styles.headerText]}>
                CONNECT
            </MyText>
            {Link('GREECE +30.210.9962680', null)}
            {Link('SWISS +', null)}
            {Link('team@footprint.com', null)}
        </View>
        <View style={[styles.column, {flexDirection: 'row'}]}>
            <AntDesign name="instagram" size={24} color="white" style={{marginRight: 15}} />
            <FontAwesome name="facebook-f" size={24} color="white" style={{marginRight: 15}} />
            <AntDesign name="twitter" size={24} color="white" style={{marginRight: 15}} />
            <FontAwesome name="youtube" size={24} color="white" style={{marginRight: 15}} />
            <Entypo name="linkedin" size={24} color="white"/>
        </View>
    </View>
    )
}

const styles = StyleSheet.create({
    column: {
        flex: 1,
        minWidth: 150
    },
    link: {
        marginBottom: 10
    },
    headerText: {
        color: 'white',
        marginBottom: 20,
        fontFamily: 'Futura Heavy'
    },
    linkText: {
        fontFamily: 'Futura Medium',
        color: 'white'
    },
    logo: {
        width: 70,
        height: 70,
        backgroundSize: 'contain',
        cursor: 'pointer'
    },
    logoText: {
        fontFamily: 'Futura Heavy',
        color: 'white',
        marginTop: 15
    }
});
